<script>
    import {COUNTRY_CODES} from "../lib/data.js";
    import {setFocusTo} from "../lib/lib.js";
    import {createEventDispatcher} from "svelte/internal";

    export let value;
    export let id = 'phone';
    export let language = 'en';
    export let disabled = false;
    export let required = false;

    let code = '';
    let phone = '';

    const dispatch = createEventDispatcher();

    const onCodeChange = () => {
        onPhoneChange();
        if (id) {
            setFocusTo(id);
        }
    }

    const onPhoneChange = () => {
        if (code && phone) {
            dispatch("change", `${code}${phone}`.replace("+", ""));
        }
    }

    if (value) {
        phone = value.slice(-10);
        code = value.replace(phone, "");
        if (code) code = `+${code}`;
    } else if (language === 'el' && !code) {
        code = `+30`;
    }

    $: {
        if (code && phone) {
            value = `${code}${phone}`.replace("+", "");
        } else {
            value = '';
        }
    }
</script>

<div class="input-group">
    <div class="country-code pointer">
        <select class="form-select form-control pointer" id="countryCodes" bind:value={code} on:change={onCodeChange}
                {required} {disabled}>
            <option value="" disabled="">Code</option>
            {#each COUNTRY_CODES as item}
                <option value="{ item.code }">{ item.name }</option>
            {/each}
        </select>
        <div class="btn btn-default">
            {#if code}
                {code}
            {:else}
                Code
            {/if}
        </div>
    </div>
    <input type="tel" class="form-control phone" {id} bind:value="{ phone }"
           oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');"
           on:change={onPhoneChange}
           {required}>
</div>

<style>
    .input-group {
        position: relative;
        display: flex;
        flex-wrap: wrap;
        align-items: stretch;
        width: 100%;
    }

    .country-code {
        position: relative;
        width: 70px;
        border-radius: 20px 0 0 20px;
        border: 1px solid #cecece;
        border-right: none;
    }

    .country-code .btn {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        /*color: #2a3091;*/
        /*background: #fff;*/
        color: #fff;
        background: #173091;
        border-radius: 20px 0 0 20px;
        z-index: 1;
    }

    .country-code .btn:hover {
        background: #00a1cb;
    }

    .country-code .form-select {
        position: absolute;
        opacity: 0;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 2;
    }

    .phone {
        width: calc(100% - 70px);
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }

    .pointer {
        cursor: pointer;
    }

    @media (min-width: 576px) {
        .country-code {
            border-radius: 4px 0 0 4px;
            border: 1px solid #cecece;
            border-right: none;
        }

        .country-code .btn {
            border-radius: 4px 0 0 4px;
        }
    }
</style>
